import { Component, ChangeDetectorRef, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { finalize } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router, RouterModule } from '@angular/router';
import { PlayerListService } from '../../../shared/services/player-list.service';
import { UserService } from '../../../shared/services/user.service';
import { PlayerListListViewModel } from '../../../shared/models/PlayerListModels';
import { MatListModule } from '@angular/material/list';
import { TranslateService } from '@ngx-translate/core';
import { CommonModule, DatePipe } from '@angular/common';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatMenuModule } from '@angular/material/menu';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { ConfirmationDialogComponent } from '../../../shared/components/confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';


export class Section {
  name: string;
  comment: string;
}

interface ScoutListGroup {
  scoutName: string;
  lists: PlayerListListViewModel[];
}

@Component({
    selector: 'app-ranking-lists',
  imports: [CommonModule, MatListModule, MatIconModule, MatDividerModule, MatMenuModule, MatButtonModule, MatToolbarModule, MatExpansionModule, MatProgressBarModule, TranslateModule, RouterModule, TranslateModule],
    templateUrl: './ranking-lists.component.html',
    styleUrl: './ranking-lists.component.css'
})

export class RankingListsComponent implements OnInit {
  lists: PlayerListListViewModel[] = [];
  myLists: PlayerListListViewModel[] = [];
  otherScoutGroups: ScoutListGroup[] = [];
  isLoading: boolean = false;
  private dialog = inject(MatDialog);
  private translate = inject(TranslateService);
  private cdr = inject(ChangeDetectorRef);
  private destroyRef = inject(DestroyRef);
  protected activeListsShown = true;
  hiddenLists: string[] = [];

/* folders: Section[] = [
        {
          name: 'Backar 2023',
          comment: 'Andreas Holmberg',
        },
        {
          name: 'Forwards 2024',
          comment: 'Matta Grundh',
        },
        {
          name: 'Backar 2023',
          comment: 'Andreas Holmberg',
        },
        {
          name: 'Forwards 2024',
          comment: 'Matta Grundh',
        },
        {
          name: 'Backar 2023',
          comment: 'Andreas Holmberg',
        },
        {
          name: 'Forwards 2024',
          comment: 'Matta Grundh',
        },
        {
          name: 'Backar 2023',
          comment: 'Andreas Holmberg',
        },
        {
          name: 'Forwards 2024',
          comment: 'Matta Grundh',
        },
        {
          name: 'Backar 2023',
          comment: 'Andreas Holmberg',
        },
        {
          name: 'Forwards 2024',
          comment: 'Matta Grundh',
        },
        {
          name: 'Backar 2023',
          comment: 'Andreas Holmberg',
        },
        {
          name: 'Forwards 2024',
          comment: 'Matta Grundh',
        },
      ];
     */
  constructor(  private listService: PlayerListService,
    private userService: UserService,
    private _snackBar: MatSnackBar,
    private _router: Router){
      
    }

    ngOnInit() {
      this.getData();  
      
    }
  
    getData(){
      if (this.isLoading) {
        // console.log('Ranking lists - already loading, skipping duplicate call');
        return;
      }
      
      this.isLoading = true;
      // console.log('Ranking lists - loading data');
      this.listService.getLists()
        .pipe(
          finalize(() => {
            // console.log('Ranking lists - finalize, setting isLoading to false');
            this.isLoading = false;
            this.cdr.detectChanges();
          })
        )
        .subscribe({
          next: (res) => {
            const lists = Array.isArray(res) ? res : [];
            this.activeListsShown = true;
            this.lists = lists;
            this.organizeLists();
            // console.log('Ranking lists - data loaded successfully, lists:', lists.length);
            this.cdr.detectChanges();
          },
          error: (err) => {
            // console.error('Error loading ranking lists:', err);
          }
        });
  }

  getArchivedLists() {
    if (this.isLoading) {
      // console.log('Ranking lists - already loading, skipping duplicate call');
      return;
    }
    
    this.isLoading = true;
    // console.log('Ranking lists - loading archived lists');
    this.listService.getArchivedLists()
      .pipe(
        finalize(() => {
          // console.log('Ranking lists - finalize, setting isLoading to false');
          this.isLoading = false;
          this.cdr.detectChanges();
        })
      )
      .subscribe({
        next: (res) => {
          const lists = Array.isArray(res) ? res : [];
          //console.log(res);
          this.activeListsShown = false;
          this.lists = lists;
          this.organizeLists();
          // console.log('Ranking lists - archived lists loaded successfully, lists:', lists.length);
          this.cdr.detectChanges();
        },
        error: (err) => {
          // console.error('Error loading archived lists:', err);
        }
      });
  }

  archiveList(List: PlayerListListViewModel) {

    var message: string;
    message = this.translate.instant("DOYOUWANTTOARCHIVELIST", {listname: List.Description});


    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '350px',
      data: message

    });

    dialogRef.afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(result => {

        if (result) {
          this.listService.archiveList(List.ListId)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(success => {
              if (success) {
            this.openSnackBar('Archived successfully', 'Close')
            //this.hiddenLists.push(List.ListId);
            this.getData();
          } else {
            this.openSnackBar('Archive failed', 'Close')
          }

        });

      } else {
        this.openSnackBar('Archive cancelled', 'Close')
      }

    });
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, { duration: 2000 });
  }

  private organizeLists(): void {
    const allLists = this.lists ?? [];

    this.myLists = allLists
      .filter(list => list.IsMyList)
      .sort((left, right) => this.sortByDescription(left, right));

    const otherLists = allLists.filter(list => !list.IsMyList);
    const groupedLists = new Map<string, PlayerListListViewModel[]>();

    for (const list of otherLists) {
      const scoutName = this.getScoutName(list);
      const scoutLists = groupedLists.get(scoutName) ?? [];
      scoutLists.push(list);
      groupedLists.set(scoutName, scoutLists);
    }

    this.otherScoutGroups = Array.from(groupedLists.entries())
      .map(([scoutName, lists]) => ({
        scoutName,
        lists: lists.sort((left, right) => this.sortByDescription(left, right))
      }))
      .sort((left, right) => left.scoutName.localeCompare(right.scoutName));
  }

  getScoutName(list: PlayerListListViewModel): string {
    return `${list.CreatedByLastName}, ${list.CreatedByFirstName}`;
  }

  private sortByDescription(left: PlayerListListViewModel, right: PlayerListListViewModel): number {
    const leftDescription = left?.Description ?? '';
    const rightDescription = right?.Description ?? '';

    return leftDescription.localeCompare(rightDescription);
  }

}
